type LocationType = 'zip' | 'state' | 'city'

const US_STATES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
]

/**
 * Determine the type of location based on the input string.
 *
 * @param {string} input - The input location string.
 * @returns {LocationType} - Returns 'zip', 'city', or 'state' depending on the format of the locationString.
 */
export function detectLocationType(input: string): LocationType {
  const trimmedInput = input.trim()

  // Check if the locationString is a zip code (2 to 5 digits)
  if (/^\d{2,5}$/.test(input)) {
    return 'zip'
  }

  // Check if full state name or abbreviation
  if (US_STATES.includes(trimmedInput.toUpperCase())) {
    return 'state'
  }

  // Otherwise, assume it's a city
  return 'city'
}
